// react
import { useMemo } from 'react';

// router
import { Link as RouterLink, useLocation } from 'react-router-dom';

// ui
import { Empty } from '../../Empty/Empty';
import { Notification } from '../../Notification/Notification';

// material
import { Box, Button } from '@mui/material';

// i18n
import { useTranslation } from 'react-i18next';

// icons
import { TimerOutlined as IconTimer } from '@mui/icons-material';

// props
import { LineItemProps } from '../../LineItem/LineItem';

// theme;
import { theme } from '../../../../theme';

export interface NotificationsProps {
	items: LineItemProps[];
}

export const Notifications = ({ items }: NotificationsProps) => {
	// hooks
	const { t } = useTranslation();
	const location = useLocation();

	// determine the "See All" link based on current path
	const seeAllLink = useMemo(() => {
		const projectMatch = location.pathname.match(/\/project\/([^/]+)/);
		if (projectMatch) {
			return `/project/${projectMatch[1]}/activities`;
		}
		return null;
	}, [location.pathname]);

	return (
		<>
			{items.length > 0 ? (
				<>
					{items.map((item, i) => {
						return (
							<Notification
								key={`notification-item-${i}`}
								date={item.date}
								hasBorder={true}
								type={item.type}>
								{item.content}
							</Notification>
						);
					})}
					{seeAllLink && (
						<Box
							sx={{
								padding: theme.spacing(2),
							}}>
							<Button component={RouterLink} fullWidth={true} to={seeAllLink} variant="outlined">
								{t('seeAllActivities')}
							</Button>
						</Box>
					)}
				</>
			) : (
				<Box sx={{ padding: theme.spacing(3) }}>
					<Empty
						content={{
							children: t('empty.activity.content'),
							variant: 'caption',
						}}
						IconCircleProps={{
							icon: <IconTimer />,
							size: 'md',
						}}
						title={{
							children: t('empty.activity.title'),
							component: 'h3',
							variant: 'h6',
						}}
					/>
				</Box>
			)}
		</>
	);
};
